<template>
	<el-container class="healthy page-x" direction="vertical">
		<div class="search-x">
			<div class="search-tab">
				<span class="label">项目</span>
				<el-button
					v-for="item in searchTab"
					:key="item.code"
					:type="orderType == item.code ? 'primary' : ''"
					@click="toSearchTab(item.code)"
					>{{ item.name }}
				</el-button>
			</div>

			<div class="search-item">
				<span class="label">机构</span>
				<el-select v-model="searchBox.orgLevel" placeholder="请选择">
					<el-option
						v-for="item in orgLevelList"
						:key="item.id"
						:label="item.name"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">日期</span>
				<el-date-picker
					v-model="timeCache.treatmentTime"
					@change="
						(e) => toChangeTime(e, 'orderStartTime', 'orderEndTime')
					"
					type="daterange"
					value-format="timestamp"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					unlink-panels
					:picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
					}"
				>
					<!-- :default-time="['00:00:00', '23:59:59']" -->
				</el-date-picker>
			</div>
			<el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
				>查询</el-button
			>
			<el-button
				v-auth="'sa_order_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_order_page'"
				type="warning"
				@click="exportSupplier"
				>导出报表</el-button
			>
		</div>
		<div class="cont-x">
			<div class="table-x" ref="tableBox">
				<div class="tableItem">
					<div
						class="nameBox"
						v-for="item in channelList"
						:key="item.key"
					>
						{{ item.name }}
					</div>
				</div>

				<div class="tableItemWrap">
					<div v-for="item in channelDataList" :key="item.org">
						<div v-for="(list, index) in channelList" :key="index">
							{{ item[list.key] }}
						</div>
					</div>
					<div class="emptyItem" v-if="channelDataList.length == 0">
						暂无数据
					</div>
				</div>
			</div>
		</div>
	</el-container>
</template>

<script>
	import { dateFormat } from "@/assets/js/until.js";
	// 带全选功能的下拉框
	import SelectAll from "@/components/SelectAll";
	import _ from "loadsh";

	export default {
		name: "Customer",
		components: {
			SelectAll,
		},
		data() {
			return {
				timeCache: {
					treatmentTime: [
						new Date(2023, 0, 1).getTime(),
						new Date(
							new Date(new Date().toLocaleDateString()).getTime() +
								24 * 60 * 60 * 1000 -
								1000
						),
					],
				}, // 时间缓存
				orgLevelList: [
					{
						id: "1",
						name: "一级",
					},
					{
						id: "2",
						name: "二级",
					},
				],
				orderType: "7",
				searchTab: [
					{ name: "核保体检", code: "7" },
					{ name: "健康体检", code: "6" },
					{ name: "电话医生", code: "4" },
					{ name: "视频医生", code: "5" },
					{ name: "专家预约", code: "1" },
					{ name: "专家手术", code: "3" },
					{ name: "专家病房", code: "2" },
				],
				channelList: [],
				channelDataList: [],
				// table表格
				loading: false,
				tableData: [], // table数据
				total: 0,
				timeDefaultShow: "",
				// 查询条件
				searchBox: {
					orgLevel: "1",
					orderStartTime: new Date(2023, 0, 1).getTime(),
					orderEndTime: new Date(
						new Date(new Date().toLocaleDateString())
					).getTime(),
				}, // 搜索条件
				value2: "", // 日期
			};
		},
		created() {
			// 面包导航
			this.$root.breadList = [
				{ name: "报表中心", link: "" },
				{ name: "财务报表", link: "" },
			];
			// this.channelDataList = this.channelList[this.code];
		},
		mounted() {
			// this.dataTime();
			this.getData();
		},
		methods: {
			toSearchTab(code) {
				this.orderType = code;

				this.getData();
			},
			/**
			 * 搜索按钮
			 */
			toSearch() {
				this.getData();
			},
			/**
			 * 获取数据
			 */
			getData() {
				this.loading = true;
				let params = Object.assign({}, this.searchBox, {
					orderType: this.orderType,
				});
				Object.keys(params).forEach((key) => {
					if (
						Object.prototype.toString.call(params[key]) ===
						"[object Array]"
					) {
						params[key] =
							params[key].length == 1
								? params[key][0]
								: params[key].join(",");
					}
				});
				if (!params.sellChannels) delete params.sellChannels;
				this.axios
					.get(this.getApiUrl("financeQuery"), {
						params,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.channelDataList = res.data.data || [];
							this.channelList = res.data.columnKeys || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			/**
			 * 换页
			 */

			// 导出财务报表
			exportSupplier() {
				let urlPath = this.getApiUrl("financeExport");
				let date = dateFormat(new Date());
				let query = Object.assign({}, this.searchBox, {
					orderType: this.orderType,
				});
				let param = this.$root.optionProcess(
					JSON.parse(JSON.stringify(query))
				);

				if (param.areaId) delete param.areaId;
				let fileName = `财务报表${date.replace(/-/g, "").slice(0, 8)}`;
				this.$root.exportFile(urlPath, param, fileName);
			},

			handleCurrentChange(val) {
				this.getData();
			},
			/**
			 * 时间回调函数
			 */
			toChangeTime(val, startName, endName) {
				if (val && val.length) {
					this.searchBox[startName] = val[0];
					this.searchBox[endName] = val[1];
				} else {
					this.searchBox[startName] = "";
					this.searchBox[endName] = "";
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.search-tab {
		margin: 20px 0px;
	}
	.tableItem {
		height: max-content;
		font-size: 14px;
		font-weight: 600;
		color: #2f3035;
		width: 100%;
		display: flex;
		justify-content: space-evenly;
		border-bottom: 1px solid #ebeef5;
		align-items: center;
		background-color: #8fc7ff;
		color: #252b3d;
		.nameBox {
			width: 100%;
			text-align: center;
			border-right: 1px solid #ebeef5;
			vertical-align: middle;
			padding-left: 10px;
			padding-right: 10px;
			line-height: 44px;
		}
	}
	.tableItemWrap {
		height: max-content;
		background: #fafafa;
		font-size: 14px;
		font-weight: 600;
		color: #2f3035;
		width: 100%;
		.emptyItem {
			line-height: 60px;
			width: 100%;
			color: #909399;
		}
		> div {
			display: flex;
			justify-content: space-evenly;
			align-items: center;
			border-top: 1px solid #e6e6e9;
			> div {
				width: 100%;
				text-align: center;
				border-right: 1px solid #ebeef5;
				vertical-align: middle;
				padding-left: 10px;
				padding-right: 10px;
				line-height: 44px;
			}
		}
	}
</style>